import React, {Component} from 'react';
import { Route } from 'react-router-dom';
import "./style.css";
class PrivateRoute extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAuthenticated: localStorage.getItem("userId")
        }
    }

    componentWillMount() {
        if(this.state.isAuthenticated == 200){
            setTimeout(() => {
                window.history.back(-1);
            }, 1000)
        }
    }
    render() {
        let { component: Component, ...rest} = this.props;
        // return  this.state.isAuthenticated ?
        //     (<Route {...rest} render={(props) => ( <Component {...props} />
        //     )}/> ) : (<p className="unregistered">您还没有登录，将自动跳转至上一级</p>)
        if(this.state.isAuthenticated == 200){
            return(<p className="unregistered">您还没有登录，将自动跳转至上一级</p>)
        }else{
            return(<Route {...rest} render={(props) => ( <Component {...props} />
            )}/>)
        }
    }
}

export default PrivateRoute;